import { ReactElement } from 'react';
import PerformableGroupForm from '~/components/performable/PerformableGroupForm';
import Sections from '~/components/layout/Sections';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { McmPhotoInclude } from '~/tenants/mcm/package/common';
import McmPhotoConfig, { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';

export default function McmPackageCrossroadsBasicForm(): ReactElement {
  return (
    <Sections>
      <TenantPackageIncludes>
        <McmPhotoInclude />
      </TenantPackageIncludes>
      <PerformableGroupForm performable={McmPhotoConfig}>
        <ZodFieldHidden name="type" value={McmPhotoType.INTERIOR_EXTERIOR} />
      </PerformableGroupForm>
    </Sections>
  );
}
